import { Subject } from "rxjs"
import _ from "lodash"
import moment from "moment"
import {local, setlocal} from "data/lib/local-json"
import { Notification, NotificationQueueItem } from "data/interface/notification"
import { progress } from "components/notification/subscribe"

// private module logic //
let rawQueue = local('notificationQueue') || []
let queue: NotificationQueueItem[] = _.map(rawQueue, (n) => {
  if(n.hasProgress) {
    const component = progress('user', (event, update, unsubscribe) => {
      if (event.msg.correlationid != n.correlationid) return
      const progress = event.msg.progress < 1 ? event.msg.progress*100|0 : event.msg.progress
      if(progress == 100) {
        unsubscribe()
      }
      update(progress)
    })
    n.component = component
  }
  return n
})
const queueStream = new Subject<NotificationQueueItem[]>()
const notificationStream = new Subject<Notification>()

// public module logic //
function notify(notification: Notification): void {
  notificationStream.next(notification)
  if (notification.type == 'info') return
}

function fetchQueue(): void {
  queueStream.next(queue)
}

function enqueue(notification: NotificationQueueItem): void {
  notification.timestamp = moment().format('YYYY-MM-DD HH:mm')
  if(notification.component) {
    notification.hasProgress = true
    notification.longRunning = true
  }
  const exists = _.find(queue, (n) => n.correlationid == notification.correlationid)
  if(exists) queue = _.unionBy([notification], queue, "correlationid")
  else queue.unshift(notification)
  setlocal('notificationQueue', queue)
  queueStream.next(queue)
}

function dequeue(correlationid: string): void {
  queue = _.filter(queue, (notification) => notification.correlationid !== correlationid)
  setlocal('notificationQueue', queue)
  queueStream.next(queue)
}

function dequeueAll(): void {
  queue = []
  setlocal('notificationQueue', queue)
  queueStream.next(queue)
}

// public module interface //

const notificationService = {
  stream: () => notificationStream.asObservable(),
  queueStream: () => queueStream.asObservable(),
  notify,
  fetchQueue,
  enqueue,
  dequeue,
  dequeueAll
}

export default notificationService
